import React, {FC, HTMLProps} from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import style from './style.module.scss';
import Icon from 'components/Icon';
import {Typography} from 'components/Typography';
import {getPluralWineries} from 'core/helpers';
import {IProductSnippet} from 'shared/types/productSnippet.types';

interface IProps extends HTMLProps<HTMLDivElement>, Pick<IProductSnippet, 'availability'> {
    wineries: number;
}

export const Wineries: FC<IProps> = ({wineries, availability}) => {
    if ('FOR_RESERVATION' !== availability) {
        return null;
    }

    return (
        <div className={style.root} data-skeleton-item={true}>
            <div className={style.main}>
                <Icon icon={'Express_filled'} width={16} height={16} />
                <Typography variant={'label-12-r'}>
                    Только в {wineries} {getPluralWineries(wineries)}
                </Typography>
            </div>
        </div>
    );
};
